import { create } from 'zustand';

import { type PendingSmsMessage } from '@/models/pendingSmsChat';

export interface PendingSmsState {
  pending: readonly PendingSmsMessage[];
}

export interface PendingSmsActions {
  addPendingSms: (entry: PendingSmsMessage) => void;
  setPendingSms: (pending: readonly PendingSmsMessage[]) => void;
}

// The compose screen unmounts as soon as it navigates back, so the message it just sent
// is held here for the chat to display until the server row shows up.
export const createPendingSmsStore = () =>
  create<PendingSmsState & PendingSmsActions>((set) => ({
    pending: [],
    addPendingSms: (entry: PendingSmsMessage) =>
      set((state) => ({
        pending: [...state.pending.filter((item) => item.messageId !== entry.messageId), entry],
      })),
    setPendingSms: (pending: readonly PendingSmsMessage[]) => set({ pending }),
  }));
